export default __webpack_public_path__ + "static/media/app_logo_white.e85be385.png";